import { render, staticRenderFns } from "./CommonBack.vue?vue&type=template&id=2ccbeb0e&scoped=true&"
import script from "./CommonBack.vue?vue&type=script&lang=js&"
export * from "./CommonBack.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ccbeb0e",
  null
  
)

export default component.exports